var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3337 8.33329V9.99996C16.3337 13.2216 13.722 15.8333 10.5003 15.8333M4.66699 8.33329V9.99996C4.66699 13.2216 7.27866 15.8333 10.5003 15.8333M10.5003 15.8333V18.3333M7.16699 18.3333H13.8337M10.5003 12.5C9.11961 12.5 8.00033 11.3807 8.00033 9.99996V4.16663C8.00033 2.78591 9.11961 1.66663 10.5003 1.66663C11.881 1.66663 13.0003 2.78591 13.0003 4.16663V9.99996C13.0003 11.3807 11.881 12.5 10.5003 12.5Z",
    stroke: "#007EF5",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOutline);
export default __webpack_public_path__ + "static/media/mic_outline.0f69f008edc2883e31e5813230b0e755.svg";
export { ForwardRef as ReactComponent };